import React from 'react';
import PropTypes from 'prop-types';
export var sizes = ['xs', 'sm', 'md', 'lg', 'xl'];
export var themes = ['primary', 'inverse'];

var Loading = function Loading(_ref) {
  var size = _ref.size,
      theme = _ref.theme;
  return /*#__PURE__*/React.createElement("div", {
    className: "tds-loading"
  }, /*#__PURE__*/React.createElement("div", {
    className: "tds-loading__icon tds-loading__icon--size-".concat(size, " tds-loading__icon--theme-").concat(theme)
  }, /*#__PURE__*/React.createElement("i", {
    className: "icon icon--loading"
  })));
};

Loading.displayName = "Loading";
Loading.propTypes = {
  size: PropTypes.oneOf(sizes),
  theme: PropTypes.oneOf(themes)
};
Loading.defaultProps = {
  size: 'md',
  theme: 'primary'
};
export default Loading;